let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fAsPT")).then(() => parcelRequire('9h7Hq'));